import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import axios from "axios";
import { ActiveYearsResponse, UserResult, UserResultsResponse } from "models/Models";
import "./History.scss";
import { Box, Tab, Tabs } from "@mui/material";

export const History = () => {
  const [years, setYears] = useState<number[]>([]);
  const [year, setYear] = useState<number>();
  const [users, setUsers] = useState<UserResult[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    axios.get<ActiveYearsResponse>(`${process.env.REACT_APP_API_URL}/pick/years/active`).then((r) => {
      r.data.years.sort((a,b) => a > b ? -1 : 1);
      setYears(r.data.years);
      setYear(r.data.years[0]);
      setIsLoading(false);
    });
  }, []);

  useEffect(() => {
    if (!year) return;
    setIsLoading(true);
    axios.get<UserResultsResponse>(`${process.env.REACT_APP_API_URL}/user/results/all/${year}`).then((r) => {
      setUsers(r.data.results);
      setIsLoading(false);
    });
  }, [year]);

  const pointsColumnWidth = 100;

  const getPointsDisplay = (value: number | undefined, pickCount: number | undefined) => {
    if (value !== undefined && value !== null) return value;
    return (pickCount || 0) > 0 ? 0 : null;
  };

  const getPickPercentDisplay = (value: number | undefined) => {
    if (value !== undefined && value !== null) return `${Math.round(value * 100)}%`;
    return "0%";
  };

  const columns: GridColDef[] = [
    { field: "teamName", headerName: "Name", width: 150 },
    {
      field: "firstRoundPoints",
      headerName: "Round 1",
      width: pointsColumnWidth,
      type: "number",
      valueGetter: ({ value, row }) => getPointsDisplay(value, row.round1PickCount),
    },
    {
      field: "secondRoundPoints",
      headerName: "Round 2",
      width: pointsColumnWidth,
      type: "number",
      valueGetter: ({ value, row }) => getPointsDisplay(value, row.round2PickCount),
    },
    {
      field: "thirdRoundPoints",
      headerName: "Round 3",
      width: pointsColumnWidth,
      type: "number",
      valueGetter: ({ value, row }) => getPointsDisplay(value, row.round3PickCount),
    },
    {
      field: "finalRoundPoints",
      headerName: "Cup Final",
      width: pointsColumnWidth,
      type: "number",
      valueGetter: ({ value, row }) => getPointsDisplay(value, row.round4PickCount),
    },
    {
      field: "pickPercent",
      headerName: "Pick %",
      width: pointsColumnWidth,
      type: "number",
      valueGetter: ({ value }) => getPickPercentDisplay(value),
    },
    {
      field: "total",
      headerName: "Total",
      width: pointsColumnWidth,
      type: "number",
      valueGetter: ({ value, row }) => getPointsDisplay(value, row.totalPickCount),
    },
  ];

  const handleYearChange = (_: React.SyntheticEvent, value: number) => {
    setYear(value);
  };

  return (
    <div className="results-page">
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile value={year} onChange={handleYearChange} aria-label="basic tabs example">
          {years.map((y) => (
            <Tab label={y} value={y} key={y} />
          ))}
        </Tabs>
      </Box>
      <div className="data-grid-container">
        <DataGrid getRowId={(c) => c.userId} rowHeight={30} hideFooter={true} rows={users} columns={columns} loading={isLoading} />
      </div>
    </div>
  );
};
